"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.donePromise = void 0;

const donePromise = () => {
  let resolver;
  let rejecter;
  const promise = new Promise((resolve, reject) => {
    resolver = resolve;
    rejecter = reject;
  });

  function done(error, value) {
    setImmediate(() => {
      if (error === undefined) {
        resolver(value);
      } else {
        rejecter(error);
      }
    });
  }

  return {
    done,
    promise
  };
};

exports.donePromise = donePromise;